import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_POSTBACKS = Symbol('postbacks');

export const AFFILIATE_POSTBACKS_ROUTE_NAME = Symbol('affiliate.postbacks');
export const AFFILIATE_POSTBACKS_LIST_ROUTE_NAME = Symbol('affiliate.postbacks.list');

export const ADMIN_POSTBACKS_ROUTE_NAME = Symbol('admin.postbacks');
export const ADMIN_POSTBACKS_LIST_ROUTE_NAME = Symbol('admin.postbacks.list');

export const ADMIN_POSTBACKS_LIST_URL = 'admin/affiliates/:id/webhooks/list';
export const AFFILIATE_POSTBACKS_LIST_URL = 'affiliate/webhooks/list';
export const POSTBACKS_LIST_QUERY_KEY = 'postbacks.list';

export const ADMIN_POSTBACKS_AFFILIATE_DETAILS_URL = 'admin/affiliates/:id/webhooks/affiliate_options';
export const POSTBACKS_AFFILIATE_DETAILS_QUERY_KEY = 'postbacks.affiliate-details';

export const ADMIN_POSTBACK_STATUS_ACTIVE_URL = 'admin/affiliates/:id/webhooks/:postbackId/active';
export const ADMIN_POSTBACK_STATUS_INACTIVE_URL = 'admin/affiliates/:id/webhooks/:postbackId/inactive';
export const AFFILIATE_POSTBACK_STATUS_ACTIVE_URL = 'affiliate/webhooks/:postbackId/active';
export const AFFILIATE_POSTBACK_STATUS_INACTIVE_URL = 'affiliate/webhooks/:postbackId/inactive';
export const POSTBACKS_STATUS_CHANGE_MUTATION_KEY = 'postbacks.status-change';

export const ADMIN_POSTBACKS_CREATE_URL = 'admin/affiliates/:id/webhooks';
export const AFFILIATE_POSTBACKS_CREATE_URL = 'affiliate/webhooks';
export const POSTBACKS_CREATE_MUTATION_KEY = 'postbacks.create';

export const POSTBACKS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.AFFILIATES_SHOW, PermissionsList.affiliate.WEBHOOKS_ALL),
};
